import {useEffect} from 'react';

import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import LayoutPage from 'layouts/LayoutPage/LayoutPage';
import {debounce} from 'lodash';
import {setNavigationTitleAC} from 'store/app/appSlice';
import {setBreweryFiltersAC} from 'store/breweries/breweriesSlice';
import {getBreweriesACS} from 'store/breweries/requestAC';

import {BreweriesTable} from './BreweriesTable/BreweriesTable';
import NavbarContent from './NavbarContent/NavbarContent';

import './Breweries.scss';

const Breweries = () => {
  const dispatch = useSetGlobalState();
  const {filters} = useGlobalState((state) => state.breweries);

  useEffect(() => {
    dispatch(getBreweriesACS({...filters, page: 1}));
    // eslint-disable-next-line
  }, [filters]);

  const handleSearch = (name: string) => {
    dispatch(setBreweryFiltersAC({...filters, name}));
  };

  const debouncedSearch = debounce(handleSearch, 500);

  useEffect(() => {
    dispatch(setNavigationTitleAC('breweries'));
    // eslint-disable-next-line
  }, []);

  return (
    <LayoutPage navbarChildren={<NavbarContent value={filters.name} onChange={debouncedSearch} />}>
      <div className="breweries">
        <BreweriesTable />
      </div>
    </LayoutPage>
  );
};

export default Breweries;
